import { Menu, menuClasses, menuItemClasses, MenuProps, paperClasses, styled, svgIconClasses } from '@mui/material';

export const StyledMenu = styled(Menu)(({ theme }) => ({
    [`& .${paperClasses.root}`]: {
        background: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadiusExtraLarge,
        minWidth: '260px',
        height: 'fit-content',
        boxShadow: theme.shadows[24],
        [`& .${menuClasses.list}`]: {
            padding: '0px',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
            fontSize: 18,
        },
        [`& .${menuItemClasses.root}`]: {
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3),
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            height: '40px',
            fontSize: 18,
            [`& .${svgIconClasses.root}`]: {
                fontSize: 18,
            },
            '&:active': {
                backgroundColor: 'rgba(0,110,187,0.1)',
            },
        },
    },
}));
export const defaultMenuProps: Partial<MenuProps> = {
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'right',
    },
};
